<template>
  <div class="notifications">
    <!-- <div class="box is-shadowless"> -->
      <notifications-table :type="type" :model="model" :perPage="perPage" />
    <!-- </div> -->
  </div>
</template>
<script>
import NotificationsTable from "./partials/table";
export default {
	props: ['type', 'model', 'perPage'],
	components: {
		NotificationsTable
	}
};
</script>



// WEBPACK FOOTER //
// src/components/pages/Notifications/list/index.vue